import React, { forwardRef } from 'react';
import { Icon } from '@spaceshipapp/cambridge';
import { InputWrapper, AddonWrapper } from '../Input';
import { Button } from './styled';

interface Props extends React.ButtonHTMLAttributes<HTMLDivElement> {
  isError?: boolean;
  disabled?: boolean;
}

const SelectButton = (props: Props, ref: React.ForwardedRef<HTMLButtonElement>) => {
  const { isError, children, disabled, ...remain } = props;

  return (
    <InputWrapper isError={isError} disabled={disabled} {...remain}>
      <Button type="button" disabled={disabled} ref={ref}>
        <span>{children}</span>
        {isError && (
          <AddonWrapper isError>
            <Icon.ErrorOutline width={24} height={24} />
          </AddonWrapper>
        )}
        <Icon.ArrowDown />
      </Button>
    </InputWrapper>
  );
};

export default forwardRef(SelectButton);
